module.exports = __webpack_public_path__ + "img/active_07.7cfa1354.jpg";